import { S3Client } from '@aws-sdk/client-s3';
import { Upload } from '@aws-sdk/lib-storage';
import { XhrHttpHandler } from '@aws-sdk/xhr-http-handler';
import { AxiosResponse } from 'axios';

import { AWSCREDENTIALS, AWSParams } from '../../shared/ts/document';
import httpRequest from '../httpRequest';
const awsS3API = {
  getAWSCredentials: async (): Promise<AWSCREDENTIALS> => {
    const { data } = (await httpRequest({
      baseURL: process.env.REACT_APP_DALGONA_GW_API_URL,
      url: `/booking-attachments-credentials`,
      method: 'GET',
    })) as AxiosResponse;

    return data;
  },

  uploadObjectToS3Bucket: async (
    {
      aws_access_key_id,
      aws_secret_access_key,
      aws_session_token,
    }: AWSCREDENTIALS,
    params: AWSParams,
    setLoadingProgressPercentage: (arg0: number) => void,
  ): Promise<unknown> => {
    try {
      const client = new S3Client({
        region: 'eu-west-1',
        credentials: {
          accessKeyId: aws_access_key_id,
          secretAccessKey: aws_secret_access_key,
          sessionToken: aws_session_token,
        },
        requestHandler: new XhrHttpHandler({}),
      });
      const upload = new Upload({
        client,
        params,
      });
      upload.on('httpUploadProgress', progress =>
        setLoadingProgressPercentage(
          (100 * (progress.loaded ?? 0)) / (progress.total ?? 1),
        ),
      );

      return upload.done();
    } catch (error) {
      console.log({ error });
    }
  },
};

export default awsS3API;
